//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.BasicPropertiesBuilder.js";
let d=[[[0,"AnsiFormSheetStandardMetricSize",1,0],[1,"BasicProperties",0,"AME.BasicPropertiesBuilder",0],[0,"FormSheetSizeOption",1,0],[0,"FormSheetStandardMetricSize",1,0],[0,"Height",1,0],[0,"Length",1,0],[0,"StandardType",1,0]],[],[]];
SPLM.AME.FormSheetBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.FormSheetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.FormSheetBuilder.SizeOption = Object.freeze({
    "Standard" : "Standard", "Custom" : "Custom"});

SPLM.AME.FormSheetBuilder.StandardMetricSize = Object.freeze({
    "A4landscape" : "A4landscape", "A3landscape" : "A3landscape", "A2landscape" : "A2landscape", "A1landscape" : "A1landscape", "A0landscape" : "A0landscape", "A4portrait" : "A4portrait"});

SPLM.AME.FormSheetBuilder.AnsiStandardMetricSize = Object.freeze({
    "A" : "A", "B" : "B", "C" : "C", "D" : "D", "E" : "E"});

SPLM.AME.FormSheetBuilder.StandardTypes = Object.freeze({
    "Iec" : "Iec", "Ansi" : "Ansi"});

export default SPLM;